import CardProject from '../../components/items/CardProject'

import management from '../../img/projects/projects.png'
import react from '../../img/technology/react.png'
import html from '../../img/technology/html.png'
import css from '../../img/technology/css.png'
import javaScript from '../../img/technology/javascript.png'

export default function Project2() {
  return (
    <div>
      <CardProject
        name="Management"
        img={management}
        text="O projeto Management é uma aplicação de gerenciamento de projetos desenvolvida em React como parte do curso A Hora de Codar ministrado por Matheus Battist. Incorporando desde conceitos básicos até técnicas avançadas do React, como o uso de hooks, roteamento e integração com APIs, o projeto oferece aos alunos uma oportunidade prática e abrangente de aplicar conhecimentos adquiridos, capacitando-os para projetos futuros e desafios profissionais. Além disso, possui um layout responsivo para dispositivos móveis e, para uma experiência completa com o backend ativo, é necessário acessar o repositório e executá-lo localmente em sua própria máquina."
        app="https://projects-five-alpha.vercel.app/"
        repo="https://github.com/RiccettoDev/projects"
        technology1={react}
        nameTechnology1="React JS"
        technology2={html}
        nameTechnology2="HTML"
        technology3={css}
        nameTechnology3="CSS"
        technology4={javaScript}
        nameTechnology4="JavaScript"
      />
    </div>
  )
}
